import { render, staticRenderFns } from "./counterCustomer.vue?vue&type=template&id=24b0c0b0&scoped=true"
import script from "./counterCustomer.vue?vue&type=script&lang=js"
export * from "./counterCustomer.vue?vue&type=script&lang=js"
import style0 from "./counterCustomer.vue?vue&type=style&index=0&id=24b0c0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b0c0b0",
  null
  
)

export default component.exports